export const en = {
    static: {
        approvalLogs: {
            title: 'Approval Logs',
            approvalOpinion: 'Approval opinion',
            startTime: 'StartTime',
            endTime: 'EndTime',
            todo: 'Todo',
            done: 'Done',
            toAssign: 'To Assign'
        },
        flowchart: {
            title: 'Flow Chart',
            processNotFound: 'process instance id is null',
            flowChart: 'Flow Chart',
            complete: 'Hide Calculated Route',
            simulation: 'Show Calculated Route',
            sequenceColor: 'Description Of Sequence Color',
            completed: 'Completed',
            calculate: 'Calculate Route',
            default: 'Default',
            suspend: 'Calculate Suspend',
            noProcess: 'Process definition not found!',
            list: 'Process List',
            noDataId: 'form id is null',
            noBizDefKey: 'process category id is null'
        }
    }
};
